import { Component, OnInit } from '@angular/core';
import { RulesService } from 'src/app/_services';
import { Constantes, USER_MENUS } from 'src/app/_shared/var.constant';
import { ApiResponse } from 'src/app/_model/policy/apiResponse';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-business-buttons',
    templateUrl: './business-buttons.component.html',
    styleUrls: ['./business-buttons.component.css']
})
export class BusinessButtonsComponent implements OnInit {
    constantes = new Constantes();
    userRol: any;
    verHogar = false;
    verPyme = false;
    verSearchPortal = false;
    showSection = false;

    private urls = {
        hogar: environment.URL_NEGOCIOS_AUTOS_NUEVO,
        pyme: environment.URL_NEGOCIOS_PYME_HOGAR,
        searchPortal: environment.URL_SEARCH_PORTAL
    };

    constructor(private rulesServices: RulesService) { }

    ngOnInit(): void {
        const currentUser = JSON.parse(sessionStorage.getItem('access_token'));
        this.userRol = currentUser.user.roles;
        this.checkMenu();
        if (this.showSection) {
            this.checkPermissions();
        }
    }

    private checkMenu() {
        const menus = JSON.parse(sessionStorage.getItem(USER_MENUS)) || [];
        this.showSection = menus.some((item: any) => item.id === 'mis-negocios');
    }

    private checkPermissions() {
        this.securityVerHogar();
        this.securityVerPyme();
        this.securityVerSearchPortal();
    }

    redirect(target: 'hogar' | 'pyme' | 'searchPortal') {
        window.location.assign(this.urls[target]);
    }

    private securityVerHogar() {
        const viewHogar = {
            rolesId: this.userRol,
            rule: this.constantes.verHogar
        };
        this.rulesServices.intlLatamEcFormSecureVerifyComponentAccess(viewHogar).subscribe((resp: ApiResponse) => {
            if (parseInt(resp.code + '', 10) === 200) {
                this.verHogar = true;
            }
        }, (err: any) => console.log(err));
    }

    private securityVerPyme() {
        const rule = {
            rolesId: this.userRol,
            rule: this.constantes.verPyme
        };
        this.rulesServices.intlLatamEcFormSecureVerifyComponentAccess(rule).subscribe((resp: ApiResponse) => {
            if (parseInt(resp.code + '', 10) === 200) {
                this.verPyme = true;
            }
        }, (err: any) => console.log(err));
    }

    private securityVerSearchPortal() {
        const viewSearch = {
            rolesId: this.userRol,
            rule: this.constantes.verSearchPortal
        };
        this.rulesServices.intlLatamEcFormSecureVerifyComponentAccess(viewSearch).subscribe((resp: ApiResponse) => {
            if (parseInt(resp.code + '', 10) === 200) {
                this.verSearchPortal = true;
            }
        }, (err: any) => console.log(err));
    }
}
